import React from "react";
import Subscriber from "../../subscriber.class";
import Storage from "../../services/storage.service";
import Events from "../../services/events.service";
import Spinner from "../../components/Spinners/Spinner";
import Helpers from "../../services/helpers";
import PlansService from "../../services/plans.service";
import Flow from "../../services/flow.service";
import Numbers from "../../services/number.service";
import SummaryPlan from "./boxes/summary-plan.component";
import SummaryDeviceBox from "./boxes/SummaryDeviceBox";
import Translations from "../../services/translation";
import SummaryAddress from "./boxes/summary-address.component"
export default class Summary extends Subscriber {
  state = {
    saved_plan: null,
    msisdn_formatted: null,
    numbertype: null,
    can_go_to_number: false,
    can_go_to_plan: false,
    expanded_tooltip : false,
    show : false
  };
  tooltipRef = React.createRef();
  componentDidMount() {
    let flags = Storage.get("flow_status_flags");
    if (flags && flags.is_plan_selected && !Storage.get("saved_plan")) {
      PlansService.getSavedPlans()
        .then((res) => {})
        .catch((error) => {});
    }
    if (flags && flags.is_number_selected && !Storage.get("number")) {
      Numbers.getNumberStatus();
    }
    if(flags && flags.is_mnp === true){
      this.setState({
        show : true
      })
    }
    this.subscriptions.push(
      Storage.get_obsrv("saved_plan").subscribe((data) => {
        this.setState({
          saved_plan: data,
        });
        if (data) {
          // Events.when_plan_is_selected();
        }
      })
    );

    this.subscriptions.push(
      Storage.get_obsrv("selectedProduct").subscribe((product) => {
        if (product) {
          let vip_type = Numbers.getProductVanity();
          this.setState({
            numbertype: vip_type,
          });
        }
      })
    );

    this.subscriptions.push(
      Flow.get_route().subscribe((data) => {
        this.setState({
          can_go_to_number:
            data !== Flow.getStepBaseOf("number") &&
            Flow.isRouteAllowed(Flow.getStepBaseOf("number")),
          can_go_to_plan:
            data !== Flow.getStepBaseOf("plan") &&
            Flow.isRouteAllowed(Flow.getStepBaseOf("plan")),
        });
      })
    );

    this.subscriptions.push(
      Storage.get_obsrv("number").subscribe((number) => {
        let msisdn = null;
        if (number && number.MSISDN) {
          msisdn = number.MSISDN;
          msisdn = Helpers.getNumberWithoutCountryCode(msisdn);
          msisdn = Helpers.formatPhoneNumber(msisdn);

          // Events.when_number_is_selected(number);
        }

        this.setState({
          msisdn_formatted: msisdn,
        });
      })
    );
    document.addEventListener("mousedown", this.handleClickOutside);
  }
  goToNumber = () => {
    Storage.clear("summary_modal");
    Storage.clear('original_num')
    Flow.goToStepBase("number");
  };

  goToPlan = () => {
    Storage.clear("summary_modal");
    Flow.goToStepBase("plan");
  };
  handleClickOutside = (event) => {
    if (
      this.tooltipRef?.current &&
      !this.tooltipRef?.current.contains(event.target)
    ) {
      this.setState({ expanded_tooltip: false });
    }
  };
  toggleTooltipDisplay = () =>{
    Events.when_user_clicks_on_temporary_number_tooltip_icon();
    this.setState({
      expanded_tooltip : !this.state.expanded_tooltip
    })
  }
  // componentWillUnmount() {
  //   document.removeEventListener("mousedown", this.handleClickOutside);
  // }
  componentWillUnmount() {
    // Unsubscribe from all subscriptions
    this.subscriptions.forEach((subscription) => {
      if (subscription && typeof subscription.unsubscribe === 'function') {
        subscription.unsubscribe();
      }
    });
    this.subscriptions = [];
  
    // Remove event listener
    document.removeEventListener('mousedown', this.handleClickOutside);
  
    // Reset any ongoing async updates (if needed)
    this.isUnmounted = true;
  }
  
  render() {
    // Storage.set("locationIsPicked", this.props.locationIsPicked, true);
    let strings = Translations["keys"][Translations.activeLang];

    let vip_class = ""
    let numObj, vip_bundle_type;
    if(this.state.saved_plan && this.state.saved_plan.VanityLevel){
      let type = Numbers.getProductVanity();
      if (type) {
        vip_class = "vmo-" + type.toLowerCase()
        vip_class = vip_class.replace("+", "");
      }
    }else{
      // check if bundle
      numObj = Storage.get("number");
      if(numObj){
        vip_bundle_type = Numbers.getVanityNameByID(numObj.VanityLevelId);
        if (vip_bundle_type) vip_class = `vmo-vip-${vip_bundle_type.toLowerCase()}`
      }
    }

    // let vip_title = vip_bundle_type? vip_bundle_type :"";
    let vip_title = "";

    let number_title = strings["NEW_PLAN_DETAILS_YOUR_NUMBER"];
    
    if (this.state.numbertype || vip_bundle_type) {
      if (vip_bundle_type){
        vip_title = `VIP-${vip_bundle_type}`
      }else{
        let key = this.state.numbertype + "-TEXT";
        vip_title = strings[key] ? strings[key] : this.state.numbertype;
      }
      vip_title = <span className="vmo-vip-color">{vip_title}</span>;
      number_title = Helpers.getSplitText(number_title, "%VIP%", vip_title);
    } else {
      number_title = this.state.show ?  strings["NUMBER_TRANSFER_TITLE"] 
      : strings["NEW_PLAN_DETAILS_YOUR_NUMBER_NON_VIP"];
    }

    let flags = Storage.get("flow_status_flags");
    let number = this.state.msisdn_formatted;
    let content = <Spinner />;

    let plan_box = "";

    let number_box = "";

    if (flags) {
      if (flags.is_number_selected) {
        number_box = <Spinner />;
      }
    }
    if(flags && flags.is_plan_selected){
      plan_box = <SummaryPlan show_vip={true}  disableDeviceEdit={this.props.disableDeviceEdit}/>;
    }

    if (number) {
      let pen = "";
      let action = "";
      if (this.state.can_go_to_number) {
        action = this.goToNumber;
      }

      if (this.props.number_pen_action) {
        action = this.props.number_pen_action;
      }
      if (action) {
        pen = (
          <div
            className="vmo-summary-edit"
            onClick={() => {
              // Events.clicks_on_summary_edit_number("", Storage.get("number"));
              Events.when_user_clicks_on_summary_edit_number();
              action();
            }}
          />
        );
      }    
      number_box = (
        <div className="vmo-summary-section">
        <div className="vmo-summary-box-wrapper">
          <div className="vmo-summary-box">
                <div className="vmo-summary-section-header">
                  <h3> 
                    {number_title}
                  </h3>
                  <div className="vmo-plan-specs">
                    <div className="vmo-plan-spec vmo-plan-spec-number">
                      <span className="vmo-plan-spec-value">{number}</span>
                    </div>
                  </div>
                  {pen}
                </div>
              </div>
          </div>
        </div>
      );
    }

    if (number_box !== "" || plan_box !== "") {
      content = (
        <div className={"vmo-summary " + vip_class}>
          <h2> Summary </h2>
          <>
            {number_box}
            {plan_box}
            <SummaryDeviceBox savedPlan={this.state.saved_plan} disableDeviceEdit={this.props.disableDeviceEdit}/>
           {
            ( this.props.latlng !== undefined  || Storage.get("addressLocation")) && Storage.get("addressStepNumber") !== 1 ? (
                <SummaryAddress 
                delivery_address={this.props?.delivery_address?.value || Storage.get("addressLocation")}
                />
             ) : ''
           }
          </>
        </div>
      );
    } else {
      content = "";
    }

    return content;
  }
}
